import { observable, action, runInAction, configure, computed, makeObservable } from "mobx";
import * as Request from "superagent";
import ServicePlanModel from "./models/ServicePlanModel";
import { VehicleModelData } from "./models/ServicePlanModels";
import servicePlanCMSModel from "./models/servicePlanCMSModel";
import VariantCappedServiceTotalModel from "./models/VariantCappedServiceTotal";
import CappedPricingCMSModel from "../CappedPriceService/models/CappedPricingCMSModel";
import CappedPricingServiceModel from "../CappedPriceService/models/CappedPricingServiceModel";
import { ApiBasePath } from "../../utils/ApiBasePath";

const serviceDetailApiUrl = `${ApiBasePath.serviceDetails}/vehicle-model/`; //"/api/servicedetails/vehicle-model/";
configure({ enforceActions: "never" });

export default class ServicePlanStore {
  @observable servicePlan?: ServicePlanModel = new ServicePlanModel();
  @observable servicePlanCMSModel?: servicePlanCMSModel =
    new servicePlanCMSModel();
  @observable variantCappedServiceTotalModel?: VariantCappedServiceTotalModel =
    new VariantCappedServiceTotalModel();
  @observable cappedPricingCMSModel?: CappedPricingCMSModel =
    new CappedPricingCMSModel();
  @observable cappedPricing?: CappedPricingServiceModel =
    new CappedPricingServiceModel();
  @observable servicePlanSelectedModel?: string;
  @observable cappedPricingSelectedModel?: string;
  @observable modelVariantsSelected?: string;

  constructor() {
    makeObservable(this);
  }

  @action setServicePlanSelectedModel(newName: string) {
    this.servicePlanSelectedModel = newName;
  }

  @action setCappedPricingSelectedModel(newName: string) {
    this.cappedPricingSelectedModel = newName;
  }

  @action setModelVariantSelected(model: string) {
    this.modelVariantsSelected = model;
  }

  @action resetDetails = () => {
    this.servicePlan.reset();
    this.cappedPricing.reset();
    this.variantCappedServiceTotalModel.reset();
  };

  @computed get vehicleModelsListForSelectControlServicePlan() {
    return this.servicePlanCMSModel.response.map((x) => ({
      value: x.modelID,
      label: x.name,
    }));
  }
  @computed get vehicleModelsListForSelectControlCPS() {
    return this.cappedPricingCMSModel.response.map((x) => ({
      value: x.modelID,
      label: x.name,
    }));
  }
  
  // Computed getters to ensure MobX properly tracks nested observable changes
  @computed get servicePlanResponse() {
    return this.servicePlan?.response ?? [];
  }
  
  @computed get servicePlanIsLoading() {
    return this.servicePlan?.isLoading ?? true;
  }
  
  @computed get servicePlanIsContentExist() {
    return this.servicePlan?.isContentExist ?? false;
  }
  
  @computed get servicePlanIsRequestError() {
    return this.servicePlan?.isRequestError ?? false;
  }
  //Fecthing Umbraco CMS data
  @action fetchServicePlanContentData = () => {
    this.servicePlanCMSModel.response = window["serviceDetailsRoot"].cpsModels;
    this.servicePlanSelectedModel =
      this.servicePlanCMSModel.response[0].modelID;
  };

  //Fecthing Umbraco CMS data
  @action fetchCappedPricingContentData = () => {
    this.cappedPricingCMSModel.response =
      window["serviceDetailsRoot"].cpsModels;
    this.cappedPricingSelectedModel =
      this.cappedPricingCMSModel.response[0].modelID;
  };

  @action CalculateServicePlanTotalPrice = (model) => {
    //check if total already exists
    if (
      this.variantCappedServiceTotalModel.response.findIndex(
        (m) =>
          m.modelID.toLocaleLowerCase() === model.modelID.toLocaleLowerCase()
      ) === -1
    ) {
      const selectedDesktopModel = this.servicePlanCMSModel.response
        .find(
          (m) =>
            m.modelID.toLocaleLowerCase() === model.modelID.toLocaleLowerCase()
        )
        .variants.filter((variant) => !!variant.variantGUID);

      const selectedApiModel = this.servicePlan.response.find(
        (m) => m.id.toLocaleLowerCase() === model.modelID.toLocaleLowerCase()
      );

      let threeYearElementIndex = selectedApiModel.intervalData.findIndex(
        (item) => item.name.includes("36 months")
      );

      let i: number;

      selectedDesktopModel.forEach((element) => {
        let intervalData = null;

        if (model.name.toLowerCase().includes("outback")) {
          if (element.servicePriceVariantName.includes("Wilderness")) {
            intervalData = selectedApiModel.intervalData.filter(
              (i) =>
                i.name.includes("Health Check and Chat") ||
                i.modelVariantServicePrices.find(
                  (m) =>
                    !m.isNotApplicable && m.variantName.includes("Wilderness")
                )
            );
          } else if (element.servicePriceVariantName.includes("XT")) {
            intervalData = selectedApiModel.intervalData.filter(
              (i) =>
                i.name.includes("Health Check and Chat") ||
                i.modelVariantServicePrices.find(
                  (m) => !m.isNotApplicable && m.variantName.includes("XT")
                )
            );
          } else {
            intervalData = selectedApiModel.intervalData.filter(
              (i) =>
                i.name.includes("Health Check and Chat") ||
                i.modelVariantServicePrices.find(
                  (m) =>
                    !m.isNotApplicable &&
                    !(
                      m.variantName.includes("XT") ||
                      m.variantName.includes("Wilderness")
                    )
                )
            );
          }
        } else {
          intervalData = selectedApiModel.intervalData;
        }

        threeYearElementIndex = intervalData.findIndex((item) =>
          item.name.includes("36 months")
        );

        for (i = 0; i < intervalData.length; i++) {
          const cappedVariant = intervalData[i].modelVariantServicePrices.find(
            (variant) =>
              (variant.variantGUID as string).toUpperCase() ===
              element.variantGUID.toUpperCase()
          );

          let cappedVariantPrice = cappedVariant ? cappedVariant.price : 0;

          let variantIndex =
            this.variantCappedServiceTotalModel.response.findIndex(
              (variantTotal) =>
                (variantTotal.variantGUID as string).toUpperCase() ===
                element.variantGUID.toUpperCase()
            );

          if (variantIndex > -1) {
            let currentVariant =
              this.variantCappedServiceTotalModel.response[variantIndex];

            if (i <= threeYearElementIndex) {
              currentVariant.threeYearsPrice =
                cappedVariantPrice + currentVariant.threeYearsPrice;
            }
            currentVariant.totalPrice =
              cappedVariantPrice + currentVariant.totalPrice;
          } else {
            if (cappedVariant) {
              this.variantCappedServiceTotalModel.response.push({
                threeYearsPrice: cappedVariantPrice,
                totalPrice: cappedVariantPrice,
                variantGUID: element.variantGUID,
                modelName: model.name,
                modelID: model.modelID,
              });
            }
          }
        }
      });
    }
  };

  //Fetching vehicle api's Service Plan data
  @action fetchServicePlanData = () => {
    this.servicePlan.isLoading = true;
    let url = serviceDetailApiUrl + "service-plans";

    Request.get(url).then(
      (response) => {
        runInAction(() => {
          try {
            const vehicleModelData = response.body;

            this.servicePlan.response = this.mapToVehicleModelDataArray(
              "service-plans",
              vehicleModelData
            );

            this.servicePlan.isContentExist = true;
            this.servicePlanCMSModel.response = window[
              "serviceDetailsRoot"
            ].cpsModels.filter((models) =>
              this.servicePlan.response.some(
                (x) => x.id.toLowerCase() === models.modelID.toLowerCase()
              )
            );

            if (
              this.variantCappedServiceTotalModel.length === 0 &&
              this.servicePlanCMSModel.response.length > 0
            ) {
              this.CalculateServicePlanTotalPrice(
                this.servicePlanCMSModel.response[0]
              );
            }
          } catch (e) {
            console.error("Error processing service plan data", e);
            this.servicePlan.isRequestError = true;
          } finally {
            this.servicePlan.isLoading = false;
          }
        });
      },
      (error) => {
        console.error("Service Plan API Error:", error);
        runInAction(() => {
          this.servicePlan.reset();
          this.servicePlan.isContentExist = false;
          this.servicePlan.isLoading = false;
          this.servicePlan.isRequestError = true;
        });
      }
    );
  };
  //Fetching vehicle api's capped services data
  @action fetchCappedServices = () => {
    let url = serviceDetailApiUrl + "capped-services";
    Request.get(url).then(
      (response) => {
        runInAction(() => {
          const vehicleModelData = response.body;
          this.cappedPricing.response = this.mapToVehicleModelDataArray(
            "capped-services",
            vehicleModelData
          );
          this.cappedPricing.isServiceIntervalExist = true;
          this.cappedPricing.isRequestError = false;
          this.cappedPricingCMSModel.response = window[
            "serviceDetailsRoot"
          ].cpsModels.filter((models) =>
            this.cappedPricing.response.some(
              // (x) => x.name.toLowerCase() === models.name.toLowerCase()
              (x) => x.id.toLowerCase() === models.modelID.toLowerCase()
            )
          );
        });
      },
      (error) => {
        runInAction(() => {
          this.cappedPricing.reset();
          this.cappedPricing.isServiceIntervalExist = false;
          this.cappedPricing.isRequestError = true;
        });
      }
    );
  };

  mapToVehicleModelDataArray = (serviceType, vehicleModelData) => {
    let vehicleModels: VehicleModelData[] = [];
    vehicleModels = vehicleModelData
      .filter(function (model) {
        return model.isActive;
      })
      .sort((a, b) => this.sortFn(a.displayOrder, b.displayOrder))
      .map((model) => ({
        id: model.id,
        name: model.name,
        intervalData: this.getServicesList(
          serviceType,
          model.vehicleVariants
        ).map((serviceDescription) => ({
          name: serviceDescription,
          modelVariantServicePrices: model.vehicleVariants
            .sort((a, b) => this.sortFn(a.displayOrder, b.displayOrder))
            .filter(
              (variant) =>
                this.getServicePriceVariantName(
                  serviceType,
                  model.id,
                  variant.id
                ) !== null
            )
            .map((variant) => ({
              variantGUID: (variant.id as string).toUpperCase(),
              variantName: this.getServicePriceVariantName(
                serviceType,
                model.id,
                variant.id
              ),
              displayOrder: variant.displayOrder,
              price: this.getPrice(serviceType, variant, serviceDescription),
              isNotApplicable: this.getIsNotApplicable(
                serviceType,
                variant,
                serviceDescription
              ),
            })),
        })),
      }));
    return vehicleModels;
  };
  getIsNotApplicable = (serviceType, variant, serviceDescription) => {
    if (serviceType === "capped-services") {
      return !variant.cappedServices.cappedServices.find(
        (cappedItem) => cappedItem.description === serviceDescription
      );
    } else {
      return !variant.servicePlans.servicePlans.find(
        (servicePlanItem) => servicePlanItem.description === serviceDescription
      );
    }
  };
  getPrice = (serviceType, variant, serviceDescription) => {
    if (serviceType === "capped-services") {
      return !!variant.cappedServices.cappedServices.find(
        (cappedItem) => cappedItem.description === serviceDescription
      )
        ? variant.cappedServices.cappedServices.find(
            (cappedItem) => cappedItem.description === serviceDescription
          ).price
        : 0;
    } else {
      return !!variant.servicePlans.servicePlans.find(
        (servicePlanItem) => servicePlanItem.description === serviceDescription
      )
        ? variant.servicePlans.servicePlans.find(
            (servicePlanItem) =>
              servicePlanItem.description === serviceDescription
          ).price
        : 0;
    }
  };
  getServicesList = (serviceType, vehicleVariants) => {
    let flattened = [];
    if (serviceType === "capped-services") {
      vehicleVariants
        .sort((a, b) =>
          !!a.cappedServices &&
          !!b.cappedServices &&
          b.cappedServices.cappedServices.length >
            a.cappedServices.cappedServices.length
            ? 1
            : -1
        )
        .forEach((variant) => {
          if (!!variant.cappedServices) {
            variant.cappedServices.cappedServices
              .sort((a, b) => this.sortFn(a.displayOrder, b.displayOrder))
              .forEach((service) => flattened.push(service.description));
          }
        });
    } else {
      vehicleVariants
        .sort((a, b) =>
          !!a.servicePlans &&
          !!b.servicePlans &&
          b.servicePlans.servicePlans.length >
            a.servicePlans.servicePlans.length
            ? 1
            : -1
        )
        .forEach((variant) => {
          if (!!variant.servicePlans) {
            variant.servicePlans.servicePlans
              .sort((a, b) => this.sortFn(a.displayOrder, b.displayOrder))
              .forEach((service) => flattened.push(service.description));
          }
        });
    }

    const uniqueArray = Array.from(new Set(flattened));
    return uniqueArray;
  };

  sortFn = (a, b) => a - b;

  getServicePriceVariantName = (serviceType, modelID, vairantGUID) => {
    //find model
    let modelData = null;
    if (serviceType === "service-plans") {
      modelData = this.servicePlanCMSModel.response.find(
        (m) => !!m.modelID && m.modelID.toUpperCase() === modelID.toUpperCase()
      );
    } else if (serviceType === "capped-services") {
      modelData = this.cappedPricingCMSModel.response.find(
        (m) => !!m.modelID && m.modelID.toUpperCase() === modelID.toUpperCase()
      );
    }
    //if the model name cannot found, return null
    if (!modelData) return null;

    const variant = modelData.variants.find(
      (v) =>
        !!v.variantGUID &&
        v.variantGUID.toUpperCase() === vairantGUID.toUpperCase()
    );
    return !variant ? null : variant.servicePriceVariantName;
  };
}
